// import {MapLayer, MapLayerProps, MarkerEvents} from 'react-leaflet';
import * as L from 'leaflet';
import { loc_equal } from 'shared/map/lib/utils';
import { createElementHook, createElementObject, useLeafletContext, } from '@react-leaflet/core';
import { useEffect, useRef } from 'react';
//Сначала добавим в Leaflet.Marker возможность вращаться
const RotateMarkerExt = L.Marker.extend({
    options: {
        rotationOrigin: 'center bottom',
        rotationAngle: 0,
    },
    _applyRotation: function () {
        const oldIE = L.DomUtil.TRANSFORM === 'msTransform';
        if (this.options.rotationAngle && this._icon) {
            this._icon.style[L.DomUtil.TRANSFORM + 'Origin'] =
                this.options.rotationOrigin;
            if (oldIE) {
                //for IE 9, use the 2D rotation
                this._icon.style[L.DomUtil.TRANSFORM] =
                    'rotate(' + this.options.rotationAngle + 'deg)';
            }
            else {
                // for modern browsers, prefer the 3D accelerated version
                this._icon.style[L.DomUtil.TRANSFORM] +=
                    ' rotateZ(' + this.options.rotationAngle + 'deg)';
            }
        }
    },
    setRotationAngle: function (angle) {
        this.options.rotationAngle = angle;
        this.update();
        return this;
    },
    setRotationOrigin: function (origin) {
        this.options.rotationOrigin = origin;
        this.update();
        return this;
    },
    // @ts-ignore
    _setPos: function (pos) {
        // @ts-ignore
        const r = L.Marker.prototype._setPos.call(this, pos);
        this._applyRotation();
        return r;
    },
});
const RotateMarker = RotateMarkerExt.addInitHook(function () {
    // @ts-ignore
    const iconOptions = this.options.icon && this.options.icon.options;
    // @ts-ignore
    let iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
    if (iconAnchor)
        iconAnchor = iconAnchor[0] + 'px' + iconAnchor[1] + 'px';
    // @ts-ignore
    this.options.rotationOrigin =
        // @ts-ignore
        this.options.rotationOrigin || iconAnchor || 'center bottom';
    // @ts-ignore
    this.options.rotationAngle = this.options.rotationAngle || 0;
    // @ts-ignore
    this.on('drag', (e) => {
        e.target._applyRotation();
    });
});
function createMarker(props, context) {
    const { position, onClick, zIndexOffset, angle, icon_anchor, icon_height, icon_width, icon_class, } = props;
    const icon = L.divIcon({
        className: icon_class,
        iconSize: [icon_width, icon_height],
        iconAnchor: icon_anchor != null ? icon_anchor : [icon_width / 2, icon_height / 2],
    });
    return createElementObject(new RotateMarker(position, {
        zIndexOffset: zIndexOffset != null ? zIndexOffset : 0,
        rotationAngle: angle,
        rotationOrigin: icon_anchor != null
            ? `${icon_anchor[0]}px ${icon_anchor[1]}px`
            : 'center center',
    })
        .setIcon(icon)
        .on('click', () => onClick?.()), context);
}
function updateMarker(instance, props, prevProps) {
    if ((prevProps.icon_anchor == null && props.icon_anchor) ||
        (prevProps.icon_anchor && props.icon_anchor == null) ||
        (prevProps.icon_anchor &&
            props.icon_anchor &&
            !loc_equal(prevProps.icon_anchor, props.icon_anchor))) {
        instance.setRotationOrigin(props.icon_anchor != null
            ? `${props.icon_anchor[0]}px ${props.icon_anchor[1]}px`
            : 'center center');
    }
    //Если изменили координаты
    if (!loc_equal(prevProps.position, props.position)) {
        instance.setLatLng(props.position);
        if (props.angle)
            instance.setRotationAngle(props.angle);
    }
    //Если изменили угол поворота
    if (prevProps.angle !== props.angle) {
        if (props.angle)
            instance.setRotationAngle(props.angle);
    }
}
const useMarkerElement = createElementHook(createMarker, updateMarker);
export const RotatedMarker = (props) => {
    const context = useLeafletContext();
    const markerRef = useMarkerElement(props, context);
    const iconRef = useRef();
    const propsRef = useRef(props);
    useEffect(() => {
        const icon = L.divIcon({
            className: props.icon_class,
            iconSize: [props.icon_width, props.icon_height],
            iconAnchor: props.icon_anchor != null
                ? props.icon_anchor
                : [props.icon_width / 2, props.icon_height / 2],
        });
        iconRef.current = icon;
        markerRef.current.instance.setIcon(icon);
        const container = context.layerContainer || context.map;
        container.addLayer(markerRef.current.instance);
        return () => {
            container.removeLayer(markerRef.current.instance);
        };
    }, []);
    useEffect(() => {
        if (iconRef.current) {
            let icon_changed = false;
            //Если поменяется иконка
            if (propsRef.current.icon_class !== props.icon_class) {
                iconRef.current.options.className = props.icon_class;
                icon_changed = true;
            }
            if (propsRef.current.icon_width !== props.icon_width ||
                propsRef.current.icon_height !== props.icon_height ||
                (propsRef.current.icon_anchor == null && props.icon_anchor) ||
                (propsRef.current.icon_anchor && props.icon_anchor == null) ||
                (propsRef.current.icon_anchor &&
                    props.icon_anchor &&
                    !loc_equal(propsRef.current.icon_anchor, props.icon_anchor))) {
                iconRef.current.options.iconSize = [
                    props.icon_width,
                    props.icon_height,
                ];
                iconRef.current.options.iconAnchor =
                    props.icon_anchor != null
                        ? props.icon_anchor
                        : [props.icon_width / 2, props.icon_height / 2];
                icon_changed = true;
            }
            if (icon_changed && markerRef.current) {
                markerRef.current.instance.setIcon(iconRef.current);
            }
        }
        propsRef.current = props;
    }, [props.icon_anchor, props.icon_height, props.icon_class, props.icon_width]);
    return null;
};
